const positives1 = [
	"You're doing brilliantly by the way!",
	"You're making amazing progress!",
	"You are exceptional!",
	"Terrific work!",
	"You are excelling beyond expectations!",
	"You're doing an incredible job!",
	"You're showing remarkable dedication!",
];

const positives2 = [
	"Keep up the excellent work!",
	"Keep going strong!",
	"Stay on this amazing path!",
	"Continue this fantastic progress!",
	"Maintain this wonderful momentum!",
];

const positives3 = [
	"Thank you for your dedication!",
	"Your commitment is inspiring!",
	"Your consistency is remarkable!",
	"Your effort is truly appreciated!",
	"Your persistence is admirable!",
];

const boosts = [
	"Let's get you back on track!",
	"You can do this!",
	"We believe in you!",
	"Every step forward counts!",
	"You've got this!",
];

const randomHappyEmojis = [
	"🎉",
	"🎊",
	"🎈",
	"🎁",
	"🥇",
	"🏆",
	"⚡",
	"🎗",
	"😁",
	"🥳",
	"🤩",
	"🚀",
	"🌟",
	"🎯",
	"🙏",
	"👌",
	"👍",
	"👏",
];

const getRandomPositive = (array: string[]) => {
	return array[Math.floor(Math.random() * array.length)];
};

export const wordsOfPraise = () => getRandomPositive(positives1);
export const wordsOfEncouragement = () => getRandomPositive(positives2);
export const wordsOfSupport = () => getRandomPositive(positives3);
export const wordsOfBoost = () => getRandomPositive(boosts);
export const randomHappyEmoji = () => getRandomPositive(randomHappyEmojis);
